import ReactMarkdownParent from 'react-markdown';
import { colors, media, radius, spacing, typography } from '@lamimed/pantheon';
import styled from 'styled-components';

export const ReactMarkdown = styled(ReactMarkdownParent)`
  // TODO: Update to NewTypography
  ${typography.body_text_1}
  color: ${colors.text__primary};
  text-align: left;

  h1,
  h2,
  h3 {
    margin-bottom: ${spacing.medium};

    ${media.greaterThan('tablet')`
      margin-bottom: ${spacing.small};
    `};
  }

  h1 {
    ${typography.heading_1};
    color: ${colors.text__highlight};
  }

  h2 {
    ${typography.heading_2};
    color: ${colors.text__highlight};
    ${typography.heading_1};
  }

  h3 {
    ${typography.heading_3};
    color: ${colors.text__highlight};
  }

  h4 {
    ${typography.heading_4};
    color: ${colors.text__highlight};
  }

  p {
    margin-bottom: ${spacing.small};
    color: ${colors.text__primary};
  }

  p + h3 {
    margin-top: ${spacing.large};
  }

  span {
    ${typography.body_text_1};
    color: ${colors.text__primary};
    background: ${colors.neutral_extra_light};
    padding: 0.2rem ${spacing.small};
    margin: ${spacing.small} ${spacing.small} 0 0;
    display: inline-block;
    border-radius: ${radius.medium};
  }

  ul {
    margin-left: ${spacing.medium};
    list-style: none;
    text-align: left;
    max-width: 100%;
    margin: 0 auto ${spacing.medium};
    padding-left: ${spacing.medium};

    &.to-columns {
      ${media.greaterThan('tablet')`
        max-width: initial;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 0 ${spacing.large};
      `}
    }

    ${media.greaterThan('tablet')`
      max-width: 30rem;
    `}

    li {
      ${typography.body_text_1};
      color: ${colors.text__primary};
      display: block;
      margin: ${spacing.small} 0;
      position: relative;

      &:before {
        content: '•';
        position: absolute;
        width: ${spacing.medium};
        left: 0;
        top: 0;
        transform: translateX(-100%);
        text-align: center;
      }
    }
  }
`;
